import { Tab } from '../Tab';
import { TabButton } from '../TabButton';
import { TabsContainer } from '../TabsContainer';
import { StyledMenuContainer } from './MenuTabs.styled';

const MenuTabs = () => (
	<StyledMenuContainer>
		<TabButton>Q</TabButton>
		<TabsContainer>
			<Tab>Все ТС</Tab>
			<Tab>Избранное</Tab>
			{/* <Tab>Автомобили</Tab>
				<Tab>Мотоциклы</Tab>
				<Tab>Лодки</Tab>
				<Tab>Авиация</Tab> */}
		</TabsContainer>
		<TabButton>E</TabButton>
	</StyledMenuContainer>
);

export { MenuTabs };
